import LegalStubPage from "./LegalStubPage";

export default function RefundPolicyPage() {
  return <LegalStubPage title="Refund Policy" />;
}
